import { useTranslation } from 'react-i18next'

import Dropdown from 'common/components/dropdown'
import Radio from 'common/components/form/radio'
import Badge from 'common/components/badge'
import Icons from 'common/components/icons'
import { useTransmissionContext } from 'modules/transmission/context'
import { ON_FIRE_LANGUAGE_LABEL } from 'modules/transmission/constants'
import { useThemeContext } from 'common/context/theme'
import { Theme } from 'common/helpers/theme/themeHelper'

import './languageDropdown.scss'

const LanguageDropdown = () => {
  const { t } = useTranslation()
  const { onFireLanguages, isClub, transmissionData: { code } } = useTransmissionContext()
  const { darkMode } = useThemeContext()

  if (!onFireLanguages?.length) {
    return null
  }

  const currentLanguage = onFireLanguages.find(({ scheduleCode }) => scheduleCode === code)?.language

  return (
    <Dropdown className="language-dropdown">
      <div slot="button">
        <Badge className="is-cursor-pointer">
          {currentLanguage ? ON_FIRE_LANGUAGE_LABEL[currentLanguage] : ''}
          <Icons
            className="_ml-1"
            iconName="caret-down"
            prefix="fas"/>
        </Badge>
      </div>
      <Dropdown.Header className="language-dropdown-header" title={t('live.languages.dropdown.title')} />
      {onFireLanguages.map(({ language, scheduleCode }) => {
        const isSelected = scheduleCode === code
        const radioId = `dropdown-radio-${language.toLocaleLowerCase()}`

        const handleClick = () => {
          const searchParams = new URLSearchParams()

          isClub && (searchParams.set('referer', 'club'))
          darkMode && (searchParams.set('theme', Theme.DARK))

          location.href = `/${scheduleCode}?${searchParams.toString()}`
        }

        return (
          <Dropdown.Item
            selected={isSelected}
            onClick={handleClick}
            key={language}
            className="language-dropdown-item">
            <label htmlFor={radioId} className="language-dropdown-label">
              {ON_FIRE_LANGUAGE_LABEL[language] || ''}
            </label>
            <Radio
              id={radioId}
              checked={isSelected}
              className="language-dropdown-input"
              readOnly />
          </Dropdown.Item>
        )
      })}
    </Dropdown>
  )
}

export default LanguageDropdown
